import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

const SpendSummaryItemSkeleton = () => {
  return (
    <Card className="relative min-h-[300px] min-w-[250px] max-w-[400px] overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-lg">
      <CardHeader className="flex flex-row items-center justify-between border-b bg-gradient-to-r from-gray-50 to-gray-100 px-4 py-3">
        <Skeleton className="h-4 w-32 bg-gray-200" />
        <Skeleton className="h-4 w-32 bg-gray-200" />
      </CardHeader>
      <CardContent className="flex size-full flex-col items-center justify-center gap-6">
        <Skeleton className="h-4 w-full bg-gray-200" />
        <Separator className="" />
        <Skeleton className="h-4 w-full bg-gray-200" />
      </CardContent>
      <CardFooter className="absolute bottom-0 mt-4 w-full items-center gap-4 border-t py-2">
        <Skeleton className="h-4 w-32 bg-gray-200" />
        <Skeleton className="h-4 w-32 bg-gray-200" />
      </CardFooter>
    </Card>
  );
};
const SpendSummarySkeleton = () => {
  return (
    <div className="m-4 grid grid-cols-1 gap-4 p-4 md:grid-cols-2 lg:grid-cols-3">
      <SpendSummaryItemSkeleton />
      <SpendSummaryItemSkeleton />
      <SpendSummaryItemSkeleton />
    </div>
  );
};

export default SpendSummarySkeleton;
